// Generated by build-browser-modules.cjs from tested contract-source.

// R52 candidate only. Authenticated SDK transport; not an activated game.
import {boardFields, rollFields, MODEL_VERSION} from "./opnopoly-public-state.js";
import {checkedHistory,checkedCursor} from "./opnopoly-history.js";
import {checkedNickname,checkedProfile,checkedProfileCommand} from "./opnopoly-profile.js";
import {checkedCommunity} from "./opnopoly-community.js";
const TUTORIAL_VERSION = 'monopoly-how-to-v1';
const CAPABILITY_SCHEMA = 'opgames-monopoly-sdk-v1';
const STATE_SCHEMA = 'opgames-monopoly-state-v1';
const ROUTES = Object.freeze({state:'/v1/monopoly/state', character:'/v1/monopoly/character', roll:'/v1/monopoly/roll'});
const CHARACTERS = Object.freeze(['chinese','western','korean','japanese']);
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const ID = /^[-a-zA-Z0-9_]{16,80}$/;
const WEEK = 7 * 86400000;
const fail = code => Object.assign(new Error(code), {code});
const integer = n => Number.isSafeInteger(n) && n >= 0;
const object = value => value && typeof value === 'object' && !Array.isArray(value);
const copy = value => value == null ? null : JSON.parse(JSON.stringify(value));
const exact = (value, keys) => object(value) && Object.keys(value).sort().join(',') === keys.slice().sort().join(',');

function periodEnd(weekId) {
    if (typeof weekId !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(weekId)) throw fail('INVALID_WEEK');
    const midnight = Date.parse(weekId + 'T00:00:00Z');
    if (!Number.isFinite(midnight) || new Date(midnight).toISOString().slice(0,10) !== weekId || new Date(midnight).getUTCDay() !== 1) throw fail('INVALID_WEEK');
    return midnight - 8 * 3600000 + WEEK;
}

function checkedCapability(value, identity, now) {
    if (!object(value) || value.schema !== CAPABILITY_SCHEMA || value.enabled !== true
        || value.backendReady !== true || value.packagePolicyReady !== true || value.jackpotReady !== true
        || value.modelVersion !== MODEL_VERSION || value.tutorialVersion !== TUTORIAL_VERSION
        || value.userId !== identity.userId || value.gameId !== identity.gameId
        || typeof value.activityId !== 'string' || !/^[-a-zA-Z0-9_]{1,80}$/.test(value.activityId)
        || typeof value.packagePolicyVersion !== 'string' || !/^[-a-zA-Z0-9_.]{1,80}$/.test(value.packagePolicyVersion)
        || typeof value.tutorialVersion !== 'string' || !/^[-a-zA-Z0-9_.]{1,80}$/.test(value.tutorialVersion)
        || !integer(value.expiresAt) || value.expiresAt <= now || value.expiresAt > now + 16 * 60000
        || value.weekEndsAt !== periodEnd(value.weekId) || now >= value.weekEndsAt || now < value.weekEndsAt - WEEK) throw fail('MONOPOLY_UNAVAILABLE');
    // Deliberately project only public scope; never retain arbitrary response fields.
    return {schema:value.schema, enabled:true, backendReady:true, packagePolicyReady:true, jackpotReady:true, modelVersion:value.modelVersion,
        userId:value.userId, gameId:value.gameId, activityId:value.activityId,
        packagePolicyVersion:value.packagePolicyVersion, tutorialVersion:value.tutorialVersion, packageCatalogReady:value.packageCatalogReady===true, weekId:value.weekId,
        weekEndsAt:value.weekEndsAt, expiresAt:value.expiresAt};
}

function checkedRequest(path, payload) {
    if(path==='/v1/monopoly/community'&&payload===undefined)return 'GET';
    if(path==='/v1/monopoly/nickname'){
        if(!exact(payload,['requestId','nickname'])||typeof payload.requestId!=='string'||!ID.test(payload.requestId))throw fail('INVALID_REQUEST');
        checkedNickname(payload.nickname);return 'POST';
    }
    if (typeof path === 'string' && /^\/v1\/monopoly\/history(?:\?cursor=[A-Za-z0-9_-]{1,768})?$/.test(path) && payload === undefined) return 'GET';
    if (path === ROUTES.state && payload === undefined) return 'GET';
    if (typeof path === 'string' && /^\/v1\/monopoly\/result\?requestId=[-a-zA-Z0-9_]{16,80}$/.test(path) && payload === undefined) return 'GET';
    if (typeof path === 'string' && /^\/v1\/monopoly\/packages\?currency=(CNY|HKD)$/.test(path) && payload === undefined) return 'GET';
    if (typeof path === 'string' && /^\/v1\/monopoly\/package\?productId=[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}&currency=(CNY|HKD)$/.test(path) && payload === undefined) return 'GET';
    const fields = ['activityId','weekId','packagePolicyVersion','requestId'];
    if (path === ROUTES.character) fields.push('characterId');
    if (![ROUTES.character, ROUTES.roll].includes(path) || !exact(payload, fields)
        || typeof payload.activityId !== 'string' || !/^[-a-zA-Z0-9_]{1,80}$/.test(payload.activityId)
        || typeof payload.packagePolicyVersion !== 'string' || !/^[-a-zA-Z0-9_.]{1,80}$/.test(payload.packagePolicyVersion)
        || !ID.test(payload.requestId || '') || typeof payload.requestId !== 'string'
        || (path === ROUTES.character && !CHARACTERS.includes(payload.characterId))) throw fail('INVALID_REQUEST');
    periodEnd(payload.weekId);
    return 'POST';
}

function checkedState(value, capability) {
    if (!object(value) || value.schema !== STATE_SCHEMA || value.activityId !== capability.activityId
        || value.userId !== capability.userId || value.gameId !== capability.gameId
        || value.weekId !== capability.weekId || value.weekEndsAt !== capability.weekEndsAt
        || value.packagePolicyVersion !== capability.packagePolicyVersion
        || !integer(value.revision) || !integer(value.rolls) || !integer(value.serverNow)
        || !object(value.tutorial) || value.tutorial.version !== capability.tutorialVersion
        || typeof value.tutorial.completed !== 'boolean'
        || !(value.characterId === null || CHARACTERS.includes(value.characterId))) throw fail('INVALID_STATE');
    if(value.lastRollRequestId!==undefined&&value.lastRollRequestId!==null
        &&(typeof value.lastRollRequestId!=='string'||!ID.test(value.lastRollRequestId)))throw fail('INVALID_STATE');
    return {schema:value.schema, activityId:value.activityId, userId:value.userId,
        gameId:value.gameId, weekId:value.weekId, weekEndsAt:value.weekEndsAt,
        packagePolicyVersion:value.packagePolicyVersion, revision:value.revision, serverNow:value.serverNow,
        rolls:value.rolls, characterId:value.characterId,
        tutorial:{version:value.tutorial.version, completed:value.tutorial.completed}, ...boardFields(value),
        ...(value.profile===undefined?{}:{profile:checkedProfile(value.profile)}),
        lastRollRequestId:value.lastRollRequestId||null};
}

function requestId() {
    const crypto = globalThis.crypto;
    if (!crypto || typeof crypto.getRandomValues !== 'function') throw fail('SECURE_REQUEST_ID_UNAVAILABLE');
    return 'monopoly_' + Array.from(crypto.getRandomValues(new Uint8Array(16)), b => b.toString(16).padStart(2,'0')).join('');
}

function scope(capability) {
    return capability && [capability.userId, capability.gameId, capability.activityId,
        capability.weekId, capability.packagePolicyVersion, capability.tutorialVersion].join(':');
}

class MonopolyClient {
    constructor(api, {clock = () => Date.now(), createRequestId = requestId, onPending = () => {}, onResult = () => {}} = {}) {
        if (!api || typeof api.call !== 'function' || !api.identity || !UUID.test(api.identity.userId || '')
            || !UUID.test(api.identity.gameId || '')) throw fail('AUTHENTICATED_ADAPTER_REQUIRED');
        this.api = api;
        this.identity = {userId:api.identity.userId, gameId:api.identity.gameId};
        this.clock = clock; this.createRequestId = createRequestId; this.onPending = onPending; this.onResult = onResult;
        this.capability = null; this.state = null; this.pending = null;
        this.inFlight = null; this.generation = 0; this.disposed = false; this.lastResult = null;
    }
    setCapability(value) {
        let next = null;
        try { next = checkedCapability(value, this.identity, this.clock()); } catch (_) { /* absence stays unavailable */ }
        this.generation += 1; this.inFlight = null; this.state = null;
        if (this.pending && scope(next) !== this.pending.scope) this.pending = null;
        this.capability = next; this.lastResult = null;
        return this.view();
    }
    requireCapability() {
        if (this.disposed || this.api.disposed || this.api.identity.userId !== this.identity.userId
            || this.api.identity.gameId !== this.identity.gameId) throw fail('MONOPOLY_UNAVAILABLE');
        return checkedCapability(this.capability, this.identity, this.clock());
    }
    view() {
        let capability;
        try { capability = this.requireCapability(); } catch (_) { return {available:false, entryVisible:false, rolls:0, characterId:null, canRoll:false}; }
        if (!this.state) return {available:false, entryVisible:false, rolls:0, characterId:null, canRoll:false};
        return {available:true, entryVisible:true, activityId:capability.activityId, weekId:capability.weekId,
            rolls:this.state.rolls, characterId:this.state.characterId, state:copy(this.state), lastResult:copy(this.lastResult), hasPending:!!this.pending||!!this.state.pendingRequestId, packageCatalogReady:capability.packageCatalogReady,
            tutorialRequired:!this.state.tutorial.completed, tutorialVersion:this.state.tutorial.version,
            canChooseCharacter:this.state.tutorial.completed && this.state.characterId === null && !this.pending && !this.state.pendingRequestId,
            canRoll:this.state.tutorial.completed && this.state.rolls > 0 && this.state.characterId !== null && !this.pending && !this.state.pendingRequestId};
    }
    getPending() { return copy(this.pending); }
    restorePending(value) {
        const capability = this.requireCapability();
        if (this.pending || this.inFlight) throw fail('PENDING_REQUEST_EXISTS');
        if (!exact(value, ['scope','path','payload']) || value.scope !== scope(capability)
            || ![ROUTES.roll, ROUTES.character].includes(value.path)) throw fail('INVALID_PENDING_REQUEST');
        checkedRequest(value.path, value.payload);
        this.checkScope(value.payload, capability);
        this.pending = copy(value);
        return this.getPending();
    }
    checkScope(payload, capability) {
        if (payload.activityId !== capability.activityId || payload.weekId !== capability.weekId
            || payload.packagePolicyVersion !== capability.packagePolicyVersion) throw fail('INVALID_PENDING_REQUEST');
    }
    async community() {
        const capability=this.requireCapability(),generation=this.generation;
        const value=await this.api.call('/v1/monopoly/community');this.requireCapability();
        if(generation!==this.generation)throw fail('STALE_RESPONSE');return checkedCommunity(value,capability.weekId);
    }
    async rename(nickname) {
        checkedNickname(nickname);this.requireCapability();
        if(this.nicknameInFlight)throw fail('NICKNAME_PENDING');
        if(!this.nicknamePending||this.nicknamePending.nickname!==nickname)this.nicknamePending={requestId:this.createRequestId(),nickname};
        const payload={...this.nicknamePending},generation=this.generation;checkedRequest('/v1/monopoly/nickname',payload);
        this.nicknameInFlight=true;
        try{
            const result=await this.api.call('/v1/monopoly/nickname',payload);this.requireCapability();
            if(generation!==this.generation)throw fail('STALE_RESPONSE');
            const profile=checkedProfileCommand(result,payload.requestId,this.identity.userId);
            if(this.state?.profile&&profile.revision<this.state.profile.revision)throw fail('STALE_RESPONSE');
            if(this.state)this.state.profile=profile;this.nicknamePending=null;return {profile};
        }catch(e){if(['INVALID_NICKNAME','NICKNAME_PROHIBITED'].includes(e.code))this.nicknamePending=null;throw e;}
        finally{this.nicknameInFlight=false;}
    }
    async history(cursor=null) {
        checkedCursor(cursor);this.requireCapability();const generation=this.generation;
        const path='/v1/monopoly/history'+(cursor?'?cursor='+cursor:'');checkedRequest(path);
        const value=await this.api.call(path);this.requireCapability();
        if(generation!==this.generation)throw fail('STALE_RESPONSE');
        return checkedHistory(value,this.identity.userId);
    }
    async readRollResult(id) {
        if(typeof id !== 'string' || !ID.test(id))throw fail('INVALID_REQUEST');
        const capability=this.requireCapability(), generation=this.generation;
        const path='/v1/monopoly/result?requestId='+id;checkedRequest(path);
        const value=await this.api.call(path);this.requireCapability();
        if(generation!==this.generation)throw fail('STALE_RESPONSE');
        if(!object(value)||value.status!=='COMPLETED'||value.requestId!==id)throw fail('INVALID_RESULT');
        checkedState(value.state,capability);
        return {status:'COMPLETED',requestId:id,...rollFields(value)};
    }
    async refresh() {
        const capability = this.requireCapability(), generation = this.generation;
        checkedRequest(ROUTES.state);
        try {
            const value = await this.api.call(ROUTES.state);
            this.requireCapability();
            if (generation !== this.generation) throw fail('STALE_RESPONSE');
            const state = checkedState(value, capability);
            // A slower read must not overwrite a later committed mutation.
            if (!this.state || state.revision >= this.state.revision) this.state = state;
            // The authoritative backend may have completed a disconnected
            // attempt. Retrieve its receipt; never manufacture or re-roll it.
            const local=this.pending?.path===ROUTES.roll?this.pending.payload.requestId:null;
            const receiptId=local||this.state.lastRollRequestId;
            if(!this.state.pendingRequestId&&receiptId&&receiptId!==this.lastResult?.requestId){
                try{
                    const receipt=await this.api.call('/v1/monopoly/result?requestId='+receiptId);
                    this.requireCapability();if(generation!==this.generation)throw fail('STALE_RESPONSE');
                    if(!object(receipt)||receipt.status!=='COMPLETED'||receipt.requestId!==receiptId)throw fail('INVALID_RESULT');
                    const settled=checkedState(receipt.state,capability);
                    if(settled.pendingRequestId)throw fail('INVALID_RESULT');
                    const result={status:'COMPLETED',requestId:receiptId,...rollFields(receipt)};
                    this.onResult(copy(result),scope(capability));
                    if(!this.state||settled.revision>=this.state.revision)this.state=settled;
                    this.lastResult=result;
                    if(this.pending?.path===ROUTES.roll&&this.pending.payload.requestId===receiptId){this.pending=null;try{this.onPending(null);}catch(_){}}
                }catch(error){
                    if(generation!==this.generation||this.disposed||this.api.disposed)throw error;
                    if(local&&error?.code==='NOT_FOUND')return this.retryPending();
                    // Keep a saved local intent for retry. A state-only client
                    // can fetch the same completed receipt on its next refresh.
                }
            }
            return this.view();
        } catch (error) {
            if (generation === this.generation) this.state = null;
            throw error;
        }
    }
    chooseCharacter(characterId) {
        this.requireCapability();
        this.requireTutorial();
        if (!CHARACTERS.includes(characterId)) throw fail('INVALID_CHARACTER');
        if (this.pending) {
            if (this.pending.path !== ROUTES.character || this.pending.payload.characterId !== characterId) throw fail('PENDING_REQUEST_EXISTS');
            return this.retryPending();
        }
        if (!this.state) throw fail('STATE_REQUIRED');
        if (this.state.characterId !== null) throw fail('CHARACTER_LOCKED');
        if (this.state.pendingRequestId) throw fail('SERVER_REQUEST_PENDING');
        return this.begin(ROUTES.character, {characterId});
    }
    roll() {
        this.requireCapability();
        this.requireTutorial();
        if (this.pending) {
            if (this.pending.path !== ROUTES.roll) throw fail('PENDING_REQUEST_EXISTS');
            return this.retryPending();
        }
        if (!this.state) throw fail('STATE_REQUIRED');
        if (!this.state.characterId) throw fail('CHARACTER_REQUIRED');
        if (this.state.rolls < 1) throw fail('NO_PURCHASED_ROLLS');
        if (this.state.pendingRequestId) throw fail('SERVER_REQUEST_PENDING');
        return this.begin(ROUTES.roll, {});
    }
    requireTutorial() {
        if (!this.state) throw fail('STATE_REQUIRED');
        if (!this.state.tutorial.completed) throw fail('TUTORIAL_REQUIRED');
    }
    begin(path, extra) {
        const capability = this.requireCapability();
        const payload = {activityId:capability.activityId, weekId:capability.weekId,
            packagePolicyVersion:capability.packagePolicyVersion, requestId:this.createRequestId(), ...extra};
        checkedRequest(path, payload);
        this.pending = {scope:scope(capability), path, payload};
        return this.retryPending();
    }
    retryPending() {
        const capability = this.requireCapability();
        this.requireTutorial();
        if (!this.pending) {
            if(this.state?.pendingRequestId)return this.refresh();
            throw fail('NO_PENDING_REQUEST');
        }
        if (this.inFlight) return this.inFlight;
        const pending = this.getPending(), generation = this.generation;
        this.checkScope(pending.payload, capability);
        checkedRequest(pending.path, pending.payload);
        // Store only the pending intent. No balance, dice, rewards, login tokens,
        // or locally fabricated success are restored from client storage.
        this.onPending(copy(pending));
        const operation = (async () => {
            const value = await this.api.call(pending.path, copy(pending.payload));
            this.requireCapability();
            if (generation !== this.generation) throw fail('STALE_RESPONSE');
            if (!object(value) || value.status !== 'COMPLETED' || value.requestId !== pending.payload.requestId) throw fail('INVALID_RESULT');
            const state = checkedState(value.state, capability);
            if (this.state && state.revision < this.state.revision) throw fail('STALE_RESPONSE');
            if (pending.path === ROUTES.character && state.characterId !== pending.payload.characterId) throw fail('INVALID_RESULT');
            const publicResult = pending.path === ROUTES.roll ? {status:'COMPLETED',requestId:value.requestId,...rollFields(value)} : null;
            // Preserve an unseen presentation reference before clearing the
            // pending command. The callback never settles or awards a roll.
            if(publicResult)this.onResult(copy(publicResult),scope(capability));
            this.lastResult = publicResult; this.state = state; this.pending = null;
            // If cleanup fails, repeating the saved request is safe only because
            // the future backend must implement the required idempotency contract.
            try { this.onPending(null); } catch (_) { /* success is already committed by server */ }
            return this.view();
        })();
        this.inFlight = operation;
        const clear = () => { if (this.inFlight === operation) this.inFlight = null; };
        operation.then(clear, clear);
        return operation;
    }
    dispose() {
        this.disposed = true; this.generation += 1; this.capability = null;
        this.state = null; this.inFlight = null; this.pending = null;
    }
}

export {MonopolyClient, checkedRequest, checkedCapability, checkedState, periodEnd,
    CAPABILITY_SCHEMA, STATE_SCHEMA, ROUTES, CHARACTERS, TUTORIAL_VERSION, MODEL_VERSION};
